import identifyVisitor from '@/sdk/careshipTracking/src/collector/identifyVisitor'
import { fetchUserToken, logger } from '@/sdk/oauth'
import store from '@/store'

const getAndSaveUserToken = (email: string, password: string) => {
  logger('getAndSaveUserToken (email: %s, password: %s)', email, password)

  if (!email || !password) {
    throw new Error('Cannot get a user token if the credentials are missing.')
  }

  return fetchUserToken(email, password)
    .then(response => {
      store.commit('auth/setUserToken', response.data)
      logger(
        'getAndSaveUserToken -> Promise succeeded, saving token %O',
        response.data,
      )
      identifyVisitor()
      return true
    })
    .catch(error => {
      logger('getAndSaveUserToken -> Promise failed with error %O', error)
      store.commit('auth/deleteAuth')
      return false
    })
}

export default getAndSaveUserToken
